// Duplicate / delete selected canvas items.

function nextKey(items, base) {
  let i = 1
  while (items[`${base}_copy${i > 1 ? i : ''}`]) i++
  return `${base}_copy${i > 1 ? i : ''}`
}

export function duplicateSelection() {
  const v2 = this.call('getCanvasV2'); if (!v2) return
  const ids = v2.selection.ids; if (!ids.length) return
  const newIds = []
  ids.forEach((id) => {
    const it = v2.items[id]; if (!it) return
    const k = nextKey(v2.items, id)
    v2.items[k] = { ...it, x: it.x + 40, y: it.y + 40, pageKey: it.pageKey }
    newIds.push(k)
  })
  // Re-render Items children + select the new ones.
  this.call('patchCanvas', { items: { ...v2.items } })
  this.call('selectMany', newIds)
  this.call('pushHistory')
  this.call('persistCanvasLayout')
}

export function deleteSelection() {
  const v2 = this.call('getCanvasV2'); if (!v2) return
  const ids = v2.selection.ids; if (!ids.length) return
  const items = { ...v2.items }
  ids.forEach((id) => { delete items[id] })
  this.call('clearSelection')
  this.call('patchCanvas', { items })
  this.call('forgetItemRefs', ids)
  this.call('pushHistory')
  this.call('persistCanvasLayout')
}
